export const NavItemEnum = {
  ADD_ONS: 'add-ons',
  BREEZE_INTELLIGENCE: 'breeze-intelligence',
  HUBSPOT_CREDITS: 'hubspot-credits',
  BUNDLE: 'bundle',
  CMS: 'cms',
  COMMERCE: 'commerce',
  CONTENT: 'content',
  FREE: 'crm',
  MARKETING: 'marketing',
  MARKETING_PLUS: 'marketing-plus',
  OPERATIONS: 'operations',
  DATA: 'data',
  RECOMMENDED: 'recommended',
  SALES: 'sales',
  SERVICE: 'service',
  SMART_CRM: 'smart-crm',
  SUITE: 'suite'
};

// List of pages that support SegmentedTabsLayout
export const SegmentedTabNavItems = [NavItemEnum.SUITE, NavItemEnum.MARKETING, NavItemEnum.SALES, NavItemEnum.SERVICE, NavItemEnum.OPERATIONS, NavItemEnum.DATA, NavItemEnum.CONTENT, NavItemEnum.SMART_CRM];
export const NavSectionEnum = {
  BUNDLE: 'bundle',
  CORE: 'core',
  ENHANCEMENTS: 'enhancements'
};
export const SegmentedNavItems = {
  [NavSectionEnum.BUNDLE]: [NavItemEnum.SUITE, NavItemEnum.FREE, NavItemEnum.BUNDLE, NavItemEnum.MARKETING_PLUS],
  [NavSectionEnum.CORE]: [NavItemEnum.RECOMMENDED, NavItemEnum.SMART_CRM, NavItemEnum.MARKETING, NavItemEnum.SALES, NavItemEnum.SERVICE, NavItemEnum.CONTENT, NavItemEnum.OPERATIONS, NavItemEnum.COMMERCE],
  [NavSectionEnum.ENHANCEMENTS]: [NavItemEnum.BREEZE_INTELLIGENCE, NavItemEnum.HUBSPOT_CREDITS, NavItemEnum.ADD_ONS]
};

// TODO: [Post-Inbound] Override SegmentedNavItems with these items
export const SegmentedNavItemsWithDataHub = {
  [NavSectionEnum.BUNDLE]: [NavItemEnum.SUITE, NavItemEnum.FREE, NavItemEnum.BUNDLE, NavItemEnum.MARKETING_PLUS],
  [NavSectionEnum.CORE]: [NavItemEnum.RECOMMENDED, NavItemEnum.SMART_CRM, NavItemEnum.MARKETING, NavItemEnum.SALES, NavItemEnum.SERVICE, NavItemEnum.CONTENT, NavItemEnum.DATA, NavItemEnum.COMMERCE],
  [NavSectionEnum.ENHANCEMENTS]: [NavItemEnum.BREEZE_INTELLIGENCE, NavItemEnum.HUBSPOT_CREDITS, NavItemEnum.ADD_ONS]
};
export const CreditsPageNavItemTabs = [NavItemEnum.SUITE, NavItemEnum.MARKETING, NavItemEnum.SALES, NavItemEnum.SERVICE, NavItemEnum.CONTENT, NavItemEnum.DATA, NavItemEnum.COMMERCE];
export function isCreditsPageNavItemTab(item) {
  return CreditsPageNavItemTabs.includes(item);
}